/**
 * QueueLayerComingSoon — placeholder shown when a not-yet-launched queue layer
 * (landers / offers) is selected. Paths-focused launch: the queue only exposes
 * paths for now. To re-enable those layers later, remove this component + its
 * usage in QueueTab and clear QUEUE_LAYERS_COMING_SOON. Do not delete early.
 * For Media Devoted | Created By Ciro Autiero
 */

import { FC } from 'react';
import { Construction } from 'lucide-react';

export interface QueueLayerComingSoonProps {
  /** The gated layer ('landers' | 'offers'). */
  layer: string;
}

const QueueLayerComingSoon: FC<QueueLayerComingSoonProps> = ({ layer }) => {
  const label = layer.charAt(0).toUpperCase() + layer.slice(1);
  return (
    <div className="flex flex-col items-center justify-center gap-2 rounded-md border border-dashed border-border bg-muted/20 px-4 py-12 text-center">
      <Construction className="h-6 w-6 text-muted-foreground" aria-hidden />
      <p className="text-sm font-semibold text-foreground">{label} queue — available soon</p>
      <p className="max-w-sm text-xs text-muted-foreground">
        The {layer} rotation queue is coming soon. For now the queue is focused on paths.
      </p>
    </div>
  );
};

export default QueueLayerComingSoon;
